import Page, { PageField } from '../InlinePage';
import React from 'react';

export default function createInlinePages(
    fields: PageField[],
    heading: string,
    height: number
): React.ReactNode[] {
    function newPage(): Page {
        return new Page(heading, height);
    }

    let page: Page = newPage();
    const pages: Page[] = [page];

    fields.forEach((field) => {
        if (page.hasNoSpaceForField(field)) {
            page = newPage();
            pages.push(page);
        }

        page.appendField(field);
    });

    return pages.map((page, index) => page.render(`page-${heading}-${index}`));
}
